import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  Table,
  Modal,
  Dropdown,
  Spinner,
  Alert
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AccountService from './AccountService';
import PageHeader from 'components/common/PageHeader';

const AccountList = () => {
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      AccountService.getAccounts()
        .then(response => {
          setAccounts(response);
          setNoDataToShow(false);
        })
        .catch(err => {
          setError('Failed to fetch accounts.');
          console.error(err);
        })
        .finally(() => setLoading(false));
    };
    fetchData();
  }, []);

  const loadAccounts = () => {};

  const handleShowDeleteModal = account => {
    setSelectedAccount(account);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedAccount(null);
    setShowDeleteModal(false);
  };

  const handleDelete = () => {
    if (selectedAccount) {
      AccountService.deleteAccount(selectedAccount.id).then(() => {
        loadAccounts();
        handleCloseDeleteModal();
      });
    }
  };

  return (
    <>
      <PageHeader
        title="Accounts"
        description="Manage your accounts here."
        className="mb-3"
      >
        <Button as={Link} to="/app/account/new" variant="primary" size="sm">
          <FontAwesomeIcon icon="plus" className="me-1" />
          New Account
        </Button>
      </PageHeader>

      <Card>
        <Card.Body>
          {loading && <Spinner animation="border" />}
          {error && <Alert variant="danger">{error}</Alert>}
          {!loading && !error && (
            <Table responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {!noDataToShow &&
                  accounts.map(account => (
                    <tr key={account.id}>
                      <td>
                        <Link to={`/app/root/account/${account.identifier}`}>
                          {account.name}
                        </Link>
                      </td>
                      <td>{account.email}</td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="link"
                            size="sm"
                            className="px-2"
                          >
                            <FontAwesomeIcon icon="ellipsis-h" />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              as={Link}
                              to={`/app/root/account/${account.identifier}/edit`}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => handleShowDeleteModal(account)}
                              className="text-danger"
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the account "{selectedAccount?.name}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AccountList;
